import { __decorate, __param } from 'tslib';
import { Inject, Injectable, ɵɵdefineInjectable, ɵɵinject, Optional, SkipSelf, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

let ConfigOauthService = class ConfigOauthService {
    constructor(param) {
        this.uri = param.config.apiUri;
        this.keyForm = param.config.keyForm;
        this.authTokenKey = param.config.authTokenKey;
        this.typeUpload = param.config.typeUpload;
        this.keyAccount = param.config.keyAccount;
        this.realm = param.config.keycloakConfig.realm;
    }
    getUri() {
        return this.uri;
    }
    getKeyForm() {
        return this.keyForm;
    }
    getAuthTokenKey() {
        return this.authTokenKey;
    }
    getTypeUpload() {
        return this.typeUpload;
    }
    getKeyAccount() {
        return this.keyAccount;
    }
    getRealm() {
        return this.realm;
    }
};
ConfigOauthService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
ConfigOauthService = __decorate([
    Injectable(),
    __param(0, Inject(APP_PARAMETER))
], ConfigOauthService);

let AuthUtilBase = class AuthUtilBase {
    constructor(platform) {
        this.platform = platform;
    }
    isPlatformMobile() {
        return this.platform.is('android') || this.platform.is('ios') || this.platform.is('cordova');
    }
    isIos() {
        return this.platform.is('ios');
    }
    prepareRedirectUri(keycloakConfig) {
        if (this.isPlatformMobile()) {
            return keycloakConfig.redirectUri;
        }
        else {
            return 'http://localhost:8100/app/dashboard';
        }
    }
    prepareRedirectLogoutUri(keycloakConfig) {
        if (this.isPlatformMobile()) {
            return keycloakConfig.redirectLogoutUri;
        }
        else {
            return 'http://localhost:8100/';
        }
    }
    prepareUserProfile(keycloakProfile) {
        try {
            // console.log('preprareUserProfile', keycloakProfile);
            return {
                uuidAccount: this.captureValue(keycloakProfile.attributes.uuidAccount),
                uuidWhiteLabel: this.captureValue(keycloakProfile.attributes.uuidWl),
                nameComplete: keycloakProfile.firstName + ' ' + keycloakProfile.lastName,
                nameFirst: keycloakProfile.firstName,
                nameInitials: this.captureValue(keycloakProfile.attributes.nameInitials),
                email: keycloakProfile.email,
                codeBank: this.captureValue(keycloakProfile.attributes.codeBank),
                nameBank: this.captureValue(keycloakProfile.attributes.nameBank),
                agencyBank: this.captureValue(keycloakProfile.attributes.agencyBank),
                numberAccountBank: this.captureValue(keycloakProfile.attributes.numberAccountBank),
                isEC: this.captureValue(keycloakProfile.attributes.isEC),
                extraAttributes: this.preparerExtraAttribute(keycloakProfile),
                userId: keycloakProfile.id,
            };
        }
        catch (e) {
            console.error('Failed to load user details', e);
        }
    }
    captureValue(value) {
        if (value && typeof value === 'object' && value.constructor === Array) {
            return value[0];
        }
        else {
            return value;
        }
    }
    preparerExtraAttribute(keycloakProfile) {
        const extras = new Array();
        if (keycloakProfile.attributes) {
            const keyNames = Object.keys(keycloakProfile.attributes);
            for (const attribute of keyNames) {
                if (attribute !== 'uuidAccount' &&
                    attribute !== 'uuidWhiteLabel' &&
                    attribute !== 'nameInitials' &&
                    attribute !== 'codeBank' &&
                    attribute !== 'nameBank' &&
                    attribute !== 'agencyBank' &&
                    attribute !== 'numberAccountBank' &&
                    attribute !== 'isEC' &&
                    attribute !== 'uuidWl') {
                    extras.push({ key: attribute, value: this.captureValue(keycloakProfile.attributes[attribute]) });
                }
            }
            return extras;
        }
        return extras;
    }
};
AuthUtilBase.ctorParameters = () => [
    { type: Platform }
];
AuthUtilBase.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthUtilBase_Factory() { return new AuthUtilBase(ɵɵinject(Platform)); }, token: AuthUtilBase, providedIn: "root" });
AuthUtilBase = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AuthUtilBase);

var StorageKeys;
(function (StorageKeys) {
    StorageKeys["OAUTH_TOKENS"] = "267e86b5-f372-11ea-b552-42642db3fedc";
})(StorageKeys || (StorageKeys = {}));

let StorageService = class StorageService {
    constructor(storage, authUtil) {
        this.storage = storage;
        this.authUtil = authUtil;
        this.tokenCurrent$ = new BehaviorSubject({});
    }
    set(key, value) {
        // console.log('adicionando no storage key: ' + key + ' value: ' + value);
        return this.storage.set(key, value).then(res => {
            // console.log('adicionando com sucesso');
            return res;
        });
    }
    loadToken() {
        this.get(StorageKeys.OAUTH_TOKENS).then(token => {
            // console.log('StorageService: getToken', token);
            if (token) {
                this.tokenCurrent$.next(token);
            }
        });
    }
    getToken() {
        return this.tokenCurrent$.getValue();
    }
    get(keyAuth) {
        // console.log('buscando no storage key: ' + keyAuth);
        if (!this.authUtil.isPlatformMobile()) {
            // console.log('buscando no storage key - forEach: ' + keyAuth);
            return this.storage.forEach((value, key, iterationNumber) => {
                if (key.indexOf(keyAuth) > -1) {
                    return this.storage.get(keyAuth).then(res => {
                        // console.log('localizado  com sucesso: ', res);
                        return res;
                    });
                }
            });
        }
        else {
            return this.storage.get(keyAuth).then(res => {
                // console.log('localizado  com sucesso: ', res);
                return res;
            });
        }
    }
    remove(key) {
        // console.log('removendo do storage key: ' + key);
        return this.storage.remove(key).then(res => {
            // console.log('removido  com sucesso: ' + res);
            return res;
        });
    }
};
StorageService.ctorParameters = () => [
    { type: Storage },
    { type: AuthUtilBase }
];
StorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(ɵɵinject(Storage), ɵɵinject(AuthUtilBase)); }, token: StorageService, providedIn: "root" });
StorageService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], StorageService);

let ApiService = class ApiService {
    constructor(http, storageService, authUtil, configService, document) {
        this.http = http;
        this.storageService = storageService;
        this.authUtil = authUtil;
        this.configService = configService;
        this.document = document;
        this.uri = this.configService.getUri();
        this.authTokenKey = this.configService.getAuthTokenKey();
    }
    prepareHttpHeaders(uuidAccountPayment, extras) {
        //  console.log('prepareHttpHeaders::zero::', uuidAccountPayment, extras);
        const httpOptions = {
            headers: new HttpHeaders({
                'X-Request-UAC': uuidAccountPayment ? uuidAccountPayment : '',
            }),
        };
        //   console.log('prepareHttpHeaders::primeiro::', httpOptions);
        if (extras) {
            for (const extra of extras) {
                httpOptions.headers = httpOptions.headers.append(extra.name, extra.value);
            }
        }
        //  console.log('prepareHttpHeaders::segundo::', httpOptions);
        return httpOptions;
    }
    getToken() {
        this.storageService.loadToken();
        const token = this.storageService.getToken();
        // console.log('ApiService: getToken', token);
        if (token && token.access_token) {
            return token.access_token;
        }
        else {
            return '';
        }
    }
    get(path) {
        const httpOptions = this.prepareHttpHeaders();
        return this.http.get(this.uri + path, httpOptions);
    }
    getWithHeaders(path, extras) {
        const httpOptions = this.prepareHttpHeaders(null, extras);
        return this.http.get(this.uri + path, httpOptions);
    }
    getBlob(path) {
        // this.storageService.loadToken();
        return this.http.get(this.uri + path, {
            headers: new HttpHeaders({
            // 'X-Realm': this.configService.getRealm()
            }),
            responseType: 'blob',
        });
    }
    postBlob(path, dateReport) {
        // this.storageService.loadToken();
        return this.http.post(this.uri + path, dateReport, {
            headers: new HttpHeaders({
            // 'X-Realm': this.configService.getRealm()
            }),
            responseType: 'blob',
        });
    }
    put(path, body, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        return this.http.put(this.uri + path, body, httpOptions);
    }
    patch(path, body, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        return this.http.patch(this.uri + path, body, httpOptions);
    }
    post(path, body, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        const uri = this.uri + path;
        return this.http.post(uri, body, httpOptions);
    }
    delete(path, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        // console.log('delete::httpOptions::', httpOptions);
        return this.http.delete(this.uri + path, httpOptions);
    }
    deleteWithBody(path, uuidAccountPayment, extras, body) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        return this.http.request('delete', this.uri + path, Object.assign({}, httpOptions, { body: body // Define o corpo da solicitação
         }));
    }
};
ApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: StorageService },
    { type: AuthUtilBase },
    { type: ConfigOauthService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
ApiService = __decorate([
    Injectable(),
    __param(4, Inject(DOCUMENT))
], ApiService);
class ExtraHeader {
}

var UiBsOauthModule_1;
let UiBsOauthModule = UiBsOauthModule_1 = class UiBsOauthModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsOauthModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsOauthModule.ctorParameters = () => [
    { type: UiBsOauthModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsOauthModule = UiBsOauthModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            HttpClientModule,
            IonicStorageModule.forRoot()
        ],
        providers: [
            ApiService,
            ConfigOauthService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsOauthModule);

class ExtraAttribute {
}
class UserProfileBase {
}

/*
 * Public API Surface of ui-bs-oauth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiService, AuthUtilBase, ConfigOauthService, ExtraAttribute, ExtraHeader, StorageKeys, StorageService, UiBsOauthModule, UserProfileBase };
//# sourceMappingURL=wlp-ui-bs-oauth.js.map
